/**
 * Incorporation Workflow Types
 * Due Diligence 완료 → AI DocGen Incorporation 전용 워크플로우
 */

export interface IncorporationDirector {
  name: string;
  nationality: string;
  isForeign: boolean;
  contactCd?: string;
  email?: string;
  idNo?: string;
  idType?: string;
}

export interface IncorporationShareholder {
  name: string;
  shareType?: string;
  contactCd?: string;
  email?: string;
  shares?: number;
}

export interface IncorporationQAState {
  icpCd: string;                         // Incorporation Entity ID
  useStandardTemplates: boolean | null;   // Q1: Lettaga 표준 템플릿 사용?
  hasForeignDirectors: boolean | null;    // Q2: 외국인 이사 있음?
  proceedWithEFiling: boolean | null;     // Q3: e-filing 진행?
  editBeforeGenerate: boolean | null;     // Q4: Entity 정보 수정?
  currentQuestion: number;                // 현재 질문 번호 (0=시작 전, 1-4, 5=완료)
  taskTitleConfirmed: boolean;            // Task Title 확인 완료
  directors: IncorporationDirector[];
  shareholders: IncorporationShareholder[];
  companyName: string;
}

export interface IncorporationQuestion {
  id: number;
  text: string;
  subText?: string;
  type: 'yesno' | 'select' | 'info';
}

export const INCORPORATION_QUESTIONS: IncorporationQuestion[] = [
  {
    id: 1,
    text: 'Would you like to proceed with Lettaga standard templates for this incorporation?',
    subText: 'We have 4 pre-configured templates for Malaysia Sdn. Bhd. incorporation.',
    type: 'yesno',
  },
  {
    id: 2,
    text: 'Are there any foreign directors among the officers?',
    subText: 'Foreign directors require Section 201 with Attestation (notarized declaration). Local directors use the standard Declaration form.',
    type: 'yesno',
  },
  {
    id: 3,
    text: 'Would you like to proceed with e-filing after document generation?',
    subText: 'If yes, an e-filing button will be available in the final step.',
    type: 'yesno',
  },
  {
    id: 4,
    text: 'Would you like to review and edit the Incorporation Entity information before generating?',
    subText: 'If no, documents will be generated automatically with the existing data.',
    type: 'yesno',
  },
];

export function createEmptyIncorporationQA(): IncorporationQAState {
  return {
    icpCd: '',
    useStandardTemplates: null,
    hasForeignDirectors: null,
    proceedWithEFiling: null,
    editBeforeGenerate: null,
    currentQuestion: 0,
    taskTitleConfirmed: false,
    directors: [],
    shareholders: [],
    companyName: '',
  };
}
